// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://plasmascan.to/address/0xEB0682d148e874553008730f0686ea89db7DA412
export const TRANSPARENT_PROXY_FACTORY = '0xEB0682d148e874553008730f0686ea89db7DA412';

// https://plasmascan.to/address/0xEf323B194caD8e02D9E5D8F07B34f625f1c088f1
export const PROTOCOL_GUARDIAN = '0xEf323B194caD8e02D9E5D8F07B34f625f1c088f1';

// https://plasmascan.to/address/0x5F29ACbFB6de4282bB4DD2017930cDA730eD864D
export const AGENT_HUB = '0x5F29ACbFB6de4282bB4DD2017930cDA730eD864D';

// https://plasmascan.to/address/0x8C29c9D5439ba69eEEBB132dE2aBd7CA1C04CF35
export const AGENT_HUB_AUTOMATION = '0x8C29c9D5439ba69eEEBB132dE2aBd7CA1C04CF35';

// https://plasmascan.to/address/0x9240a6669CC4782FC98620212862DF5CB2e0Df10
export const RANGE_VALIDATION_MODULE = '0x9240a6669CC4782FC98620212862DF5CB2e0Df10';

export const CHAIN_ID = 9745;
